import { Box, Flex } from "@chakra-ui/react";
import { RecentLearning } from "./RecentLearning";
import { NoRecentCourse } from "./noRecentCourse";
import EnrollmentList from "../enrollment-list/enrollmentlist";
import AvailableCertificates from "./AvailableCertificates";
import { useCourseManagementContext } from "@root/context/course-management-context";
import { useEffect } from "react";
import { useMyLearningContext } from "@root/context/my-learning-context";
import { useNoticeContext } from "@root/context/notice-context";
import { UnauthenticatedNoticeList } from "../UnauthenticatedDashboard/UnauthenticatedNoticeList";
import { useTranslation } from "react-i18next";
import { CardContainer, TrendingTitle } from "./style";
import ViewAllToggle from "../common/ViewAllToggle";
import { ROUTE_NAMES } from "@root/constants";
import { useNavigate } from "react-router-dom";

export const DashboardArea = () => {
  const { getMyLearningLoading, myLearningData, fetchMyLearning } =
    useMyLearningContext();
  const { fetchCourses, coursesData, getCoursesLoading } =
    useCourseManagementContext();
  const { publishNoticeData, publishNoticeLoading, fetchPublishNotice } =
    useNoticeContext();
  const { t } = useTranslation("common");
  const navigate = useNavigate();

  useEffect(() => {
    fetchCourses({ recommended: true });
    const payload = {
      isWatchLater: false,
    };
    fetchMyLearning(payload);
    fetchPublishNotice();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex direction="column" align="center" justify="center" minH="200px" gap="26px">
      {/* Top row: Recent Learning (left) and Notices (right) */}
      <Flex
        gap={6}
        width="100%"
        align="flex-start"
        flexDirection={{ base: "column", md: "row" }}
      >
        {/* Recent learning section */}
        <Box flex="1" minW="0" width="100%">
          {(!myLearningData || myLearningData?.count === 0) &&
            !getMyLearningLoading && <NoRecentCourse />}
          <RecentLearning
            courses={myLearningData?.rows}
            loading={getMyLearningLoading}
          />
        </Box>

        {/* Notices section */}
        <Box flex="1" minW="0" width="100%">
          <CardContainer>
            <Box width="100%" p={2} pb={0}>
              <Flex align="center" justify="space-between" width="100%">
                <TrendingTitle>{t("notice.noticesTitle")}</TrendingTitle>
                <ViewAllToggle
                  expanded={false}
                  onToggle={() => navigate(ROUTE_NAMES.JOURNALIST_NOTICE)}
                  showToggle={(publishNoticeData?.length ?? 0) > 0}
                />
              </Flex>
            </Box>
            <Box width="100%" px={2} pb={2} pt={2}>
              <UnauthenticatedNoticeList
                notices={publishNoticeData}
                loading={publishNoticeLoading}
                fullHeight={false}
              />
            </Box>
          </CardContainer>
        </Box>
      </Flex>

      {/* Certificates */}
      <AvailableCertificates />

      {/* Recommended courses */}
      <Box width="100%" data-tour-item="journalist-course-cards">
        <EnrollmentList
          courses={coursesData?.rows}
          loading={getCoursesLoading}
        />
      </Box>
    </Flex>
  );
};
